// frontend/src/contexts/AIProcessingContext.tsx
// TaisaCore Sprint 10: AI Processing Context for Bear State

import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { AIProcessingContextValue } from '../types/dashboard';

export const AIProcessingContext = createContext<AIProcessingContextValue | null>(null);

interface AIProcessingProviderProps {
  children: ReactNode;
}

export const AIProcessingProvider: React.FC<AIProcessingProviderProps> = ({ children }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [processingMessage, setProcessingMessage] = useState<string | null>(null);
  const [lastSuccess, setLastSuccess] = useState<number | null>(null);

  const startProcessing = useCallback((message?: string) => {
    setIsProcessing(true);
    setProcessingMessage(message || 'מעבד...');
  }, []);

  const endProcessing = useCallback((success: boolean = true) => {
    setIsProcessing(false);
    setProcessingMessage(null);
    
    if (success) {
      setLastSuccess(Date.now());
    }
  }, []);

  const value: AIProcessingContextValue = {
    isProcessing,
    processingMessage,
    lastSuccess,
    startProcessing,
    endProcessing,
  };

  return (
    <AIProcessingContext.Provider value={value}>
      {children}
    </AIProcessingContext.Provider>
  );
};

// Custom hook for using AI processing state
export const useAIProcessing = (): AIProcessingContextValue => {
  const context = React.useContext(AIProcessingContext);
  if (!context) {
    throw new Error('useAIProcessing must be used within an AIProcessingProvider');
  }
  return context;
};

export default AIProcessingContext;
